import { useState } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { api } from "../../lib/api";
import { tr } from "../../i18n";

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";

  const [password, setPassword] = useState("");
  const [confermaPassword, setConfermaPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!token) {
    return (
      <div className="min-h-screen bg-bg text-fg flex items-center justify-center p-6">
        <div className="bg-bg-card border border-danger/30 rounded-card p-8 max-w-md w-full text-center">
          <div className="text-5xl mb-4">⚠️</div>
          <h2 className="font-display text-2xl text-accent mb-2">{tr("Link non valido")}</h2>
          <p className="text-fg-muted text-sm mb-4">
            {tr("Il link di reset password non contiene un token valido.")}
          </p>
          <Link to="/forgot-password" className="btn-ghost inline-block">
            {tr("Richiedi nuovo link")}
          </Link>
        </div>
      </div>
    );
  }

  if (success) {
    return <Navigate to="/login" replace />;
  }

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (password.length < 8) {
      setError(tr("La password deve avere almeno 8 caratteri"));
      return;
    }
    if (password !== confermaPassword) {
      setError(tr("Le password non coincidono"));
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", {
        token,
        nuova_password: password,
      });
      setSuccess(true);
    } catch (err) {
      const detail = (err as { response?: { data?: { detail?: string } } }).response?.data?.detail;
      setError(detail ?? tr("Errore durante il reset password"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg text-fg flex items-center justify-center p-6">
      <div className="bg-bg-card border border-primary/30 rounded-card shadow-hero p-8 max-w-md w-full">
        <img
          src="/icon-white-192.png"
          alt="FantaSquad"
          className="w-16 h-16 mx-auto mb-4"
          onError={(e) => {
            e.currentTarget.src = "/icon-192.png";
          }}
        />
        <h1 className="font-display text-3xl text-accent text-center mb-6 tracking-wider">
          {tr("Imposta nuova password")}
        </h1>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-xs uppercase tracking-wider text-fg-muted mb-1">
              {tr("Nuova password (min 8 caratteri)")}
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete="new-password"
              className="w-full px-3 py-2 bg-primary-deep border border-primary-soft rounded-lg text-fg focus:outline-none focus:ring-2 focus:ring-accent"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-fg-muted mb-1">
              {tr("Conferma password")}
            </label>
            <input
              type="password"
              value={confermaPassword}
              onChange={(e) => setConfermaPassword(e.target.value)}
              required
              minLength={8}
              autoComplete="new-password"
              className="w-full px-3 py-2 bg-primary-deep border border-primary-soft rounded-lg text-fg focus:outline-none focus:ring-2 focus:ring-accent"
            />
          </div>

          {error && (
            <div className="text-danger text-sm bg-danger/10 border border-danger/30 rounded p-3">
              ⚠️ {error}
            </div>
          )}

          <button type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? tr("Salvataggio…") : tr("Imposta password")}
          </button>
        </form>
      </div>
    </div>
  );
}
